<script>
    export default {
        name: "stepTwo",
        props: {
            'course': Object,
            'audience': Object
        },
        data() {
            return {
                loading: false,
                disabilities: [],
                message: null,
                levels: [],
                selectedLevels: false
            }
        },
        mounted() {
            this.getDisabilities();
            this.getLevels();

            if (!this.course.levels) {
                this.course.levels = [];
            }
        },
        computed: {
            ageValidation() {
                return parseInt(this.course.startAge) >= 0 && parseInt(this.course.startAge) < parseInt(this.course.endAge);
            }
        },
        methods: {
            previousStep() {
                this.$emit('update-step', 1);
            },
            isLoading() {
                return this.loading;
            },
            getLevelButtonId(level) {
                return 'button_level_' + level.id
            },
            getDisabilities() {
                axios({
                    method: 'get',
                    url: '/disabilities'
                }).then((response) => {
                    this.disabilities = response.data.disabilities;
                }).catch((error) => {
                    this.message = 'Error';
                });
            },
            getLevels() {
                var self = this;

                axios({
                    method: 'get',
                    url: '/levels'
                }).then((response) => {
                    self.levels = response.data.levels;

                    self.levels.forEach(function (level) {
                        level.isSelected = false;
                    });
                }).catch((error) => {
                    this.message = 'Error';
                });
            },
            isSelected(level) {
                var bool = false;

                if (this.course.levels) {
                    this.course.levels.forEach(function (courseLevel) {
                        if (courseLevel.id == level.id) {
                            bool = true;
                        }
                    })
                }

                return bool;
            },
            selectLevel(level) {
                var self = this;
                if (!this.isSelected(level)) {
                    self.course.levels.push(level);
                    $('#button_level_' + level.id).addClass('form-button-selected')
                } else {
                    self.course.levels.forEach(function (selectedLevel) {
                        if (selectedLevel.id == level.id) {
                            var index = self.course.levels.indexOf(selectedLevel);
                            self.course.levels.splice(index, 1);
                            $('#button_level_' + level.id).removeClass('form-button-selected')

                        }
                    })
                }

                if (this.course.levels.length == 0) {
                    this.selectedLevels = false;
                } else {
                    this.selectedLevels = true;
                }
            },
            postForm() {
                var self = this;
                var levels = [];
                this.course.levels.forEach(function (level) {
                    levels.push(level.id)
                });
                this.validationError = {
                    name: false,
                    email: false
                };

                this.loading = true;
                this.$bus.$emit('searching');

                let formData = new FormData()
                formData.append('startAge', this.course.startAge);
                formData.append('endAge', this.course.endAge);
                formData.append('audience[forAbleBodied]', this.audience.forAbleBodied);
                formData.append('audience[forDisabled]', this.audience.forDisabled);
                formData.append('audience[checkedDisabilities]', this.audience.checkedDisabilities);
                formData.append('gender[male]', this.course.is_for_male);
                formData.append('gender[female]', this.course.is_for_female);
                formData.append('levels', levels);


                if (this.course.companyId) {
                    axios({
                        method: 'post',
                        url: '/courses/' + this.course.courseId + '/responsible_on_create',
                        data: formData,
                    }).then((response) => {
                        this.$emit('update-step', 3);
                        this.$emit('update-course-id', response.data.course.id);
                        this.loading = false;
                        this.$bus.$emit('stop-spinner');
                    }).catch((error) => {
                        this.$emit('update-course-id', response.data.course.id);
                        this.loading = false;
                        this.message = 'Error';
                        this.$bus.$emit('stop-spinner');
                    });
                } else {
                    axios({
                        method: 'post',
                        url: '/courses/' + this.course.courseId + '/responsible_on_update',
                        data: formData,
                    }).then((response) => {
                        this.$emit('update-step', 3);
                        this.$emit('update-course-id', response.data.course.id);
                        this.loading = false;
                        this.$bus.$emit('stop-spinner');
                    }).catch((error) => {
                        this.$emit('update-course-id', response.data.course.id);
                        this.loading = false;
                        this.message = 'Error';
                        this.$bus.$emit('stop-spinner');
                    });
                }
            }
        },
        watch: {
            'audience.forDisabled': {
                handler(val) {
                    console.log('val', val)
                    if (! val) {
                        console.log('test', val)
                        this.$set(this.audience, 'checkedDisabilities', [])
                    }
                },
            },
            'course.startAge': _.debounce(function () {
                if (this.course.endAge) {
                    if (parseInt(this.course.endAge) <= parseInt(this.course.startAge)) {
                        this.course.endAge = parseInt(this.course.startAge) + 1
                    }
                }
            }, 1000),
            'course.endAge': _.debounce(function () {
                if (this.course.startAge) {
                    if (parseInt(this.course.startAge) >= parseInt(this.course.endAge)) {
                        this.course.startAge = parseInt(this.course.endAge) - 1;
                    }
                }
            }, 1000),
        },
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/course/StepTwo.vue